import {WalkOfShame} from "../WalkOfShame";
import {TimelineLite} from "gsap";
import {WalkOfShameHelper} from "../../core/utils/WalkOfShameHelper";

export class FullMidCharacterOverlay extends PIXI.spine.Spine {
    private readonly _characterName: string;
    private readonly _symbolCount: PIXI.Sprite;
    private readonly _x4Texture: PIXI.Texture;
    private readonly _x8Texture: PIXI.Texture;
    private readonly _tl: TimelineLite;

    constructor(characterName: string, id: number, isWin: boolean) {
        super(WalkOfShame.assetLoader.getSpineAsset(characterName + "_full"));
        this.visible = false;
        this._characterName = characterName;
        this._reelId = id;
        this._tl = WalkOfShameHelper.createTimelineForAnimation(this, 0, "transform", false);
        this._tl.add(() => {
            this.visible = true;
        }, 0.01);
        if (!isWin) {
            this._tl.totalProgress(1);
        }

        this._x4Texture = WalkOfShame.assetLoader.getTextures("multipliers/x4")[0];
        this._x8Texture = WalkOfShame.assetLoader.getTextures("multipliers/x8")[0];

        this._symbolCount = new PIXI.Sprite();
        this.updateSymbolCountValue(4);
        this._symbolCount.visible = false;
        this._symbolCount.anchor.set(0.5);
        this._symbolCount.position.set(144 / 2 - this._symbolCount.width / 2 - 5, 288 - 25);
        this._symbolCount.rotation = 0.5;
        this.addChild(this._symbolCount);
    }

    get symbolCount(): PIXI.Sprite {
        return this._symbolCount;
    }

    get characterName(): string {
        return this._characterName;
    }

    private _reelId: number;

    get reelId(): number {
        return this._reelId;
    }

    set reelId(value: number) {
        this._reelId = value;
    }

    public updateSymbolCountValue(value: number): void {
        if (value === 4) {
            this._symbolCount.texture = this._x4Texture;
        } else {
            this._symbolCount.texture = this._x8Texture;
        }
    }

    public walk(): TimelineLite {
        this.skip();

        return (WalkOfShameHelper.createTimelineForAnimation(this, 0, "walk", false));
    }

    public win(animName: string): TimelineLite {
        this.skip();

        return (WalkOfShameHelper.createTimelineForAnimation(this, 0, animName, false));
    }

    public skip(): void {
        if (this._tl && this._tl.isActive()) {
            this._tl.totalProgress(1);
        }
    }
}